import styled from 'styled-components';
import qrCode1 from '@/assets/qrCode-1.png';
import qrCode2 from '@/assets/qrCode-2.png';
import xLogo from '@/assets/x-logo.png';
import sliceLine from '@/assets/slice-line.png';

const Footer = () => {
  return (
    <Container>
      <div>
        <div className="ttl">
        </div>
        <img src={qrCode1} alt="" className="code" />
      </div>
      <img src={sliceLine} alt="" className="line" />
      <div>
        <div className="ttl">
        </div>
        <img src={qrCode2} alt="" className="code" />
      </div>
    </Container>
  );
};

export default Footer;

const Container = styled.div`
  display: flex;
  height: 26rem;
  align-items: center;
  justify-content: center;
  margin-top:17rem;
  & > div {
    text-align: center;
    .ttl {
      margin-bottom: 0.5rem;
      span {
        font-family: '思源宋体';
        color: #e7c981;
        font-size: 1.5rem;
      }
      img {
        height: 1.5rem;
        margin-right: 0.5rem;
      }
    }
    .code {
      width:11.5rem;
      height: 14.3125rem;
    }
  }
  .line {
    height: 11rem;
    margin-top: 2rem;
    margin-inline: 6.25rem;
  }
`;
